import { render, staticRenderFns } from "./CompaniesFilter.vue?vue&type=template&id=5afaf9fa&scoped=true"
import script from "./CompaniesFilter.vue?vue&type=script&lang=js"
export * from "./CompaniesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afaf9fa",
  null
  
)

export default component.exports